module.exports = __webpack_public_path__ + "assets/e875c09a36594cffc02680e76df4f6f6.mp3";